import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { OpenAPI } from './api';

OpenAPI.HEADERS = {
  'Cache-Control': 'public, max-age=86400',
};
if (process.env.REACT_APP_VERCEL_ENV) {
  OpenAPI.WITH_CREDENTIALS = true;
  OpenAPI.CREDENTIALS = 'include';
}

if (process.env.REACT_APP_VERCEL_ENV === 'production') {
  OpenAPI.BASE = 'https://api.summerwood.com';
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
